import { z } from 'zod';
import { ValidationPatterns } from './shared';
const BaseWordCollectionSchema = z.object({
  id: ValidationPatterns.flexibleObjectId,
  userId: ValidationPatterns.flexibleObjectId,
  wordIds: z.array(ValidationPatterns.flexibleObjectId),
  date: ValidationPatterns.flexibleDate,
  createdAt: ValidationPatterns.flexibleDate,
  updatedAt: ValidationPatterns.flexibleDate,
});
export const WordCollectionSchemas = {
  full: BaseWordCollectionSchema,
  create: BaseWordCollectionSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  }),
  display: BaseWordCollectionSchema.pick({
    id: true,
    date: true,
  }).extend({
    wordCount: z.number().min(0),
    topics: z.array(z.string().min(1).max(100)),
  }),
} as const;
export type WordCollection = z.infer<typeof BaseWordCollectionSchema>;
export type CreateWordCollection = z.infer<typeof WordCollectionSchemas.create>;
export type DisplayWordCollection = z.infer<
  typeof WordCollectionSchemas.display
>;
